/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MediaDTO = {
    archived: boolean;
    createdAt: string;
    deviceType: string;
    id: string;
    imageUrl: string;
    metadata?: Record<string, any>;
    microscopeType: string;
    reactants?: string;
    status: MediaDTO.status;
    title?: string;
    zoom: number;
};

export namespace MediaDTO {

    export enum status {
        APPROVED = 'APPROVED',
        PENDING = 'PENDING',
        REJECTED = 'REJECTED',
    }


}

